import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import Card from './card.js'
import { setLoading } from '../../../action/loading-actions'

class Merchant extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.props.setLoading(false)
  }

  render() {
    const pName = window.location.pathname
    return (
      <div>
        {
          pName == '/redeem' || pName == '/claim' ? <Card /> : null
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch => ({
  setLoading: bool => dispatch(setLoading(bool))
})

export default connect(mapStateToProps, mapDispatchToProps)(Merchant)